'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

function useAfterFirstTruthy(val) {
  var mounted = React.useRef();

  if (val && !mounted.current) {
    mounted.current = true;
  }

  if (mounted.current) return true;
  return false;
}

var LazyMount = function (_a) {
  var children = _a.children,
      _b = _a.trigger,
      trigger = _b === void 0 ? false : _b,
      fallback = _a.fallback;
  var isMounted = useAfterFirstTruthy(trigger);

  if (!isMounted) {
    return null;
  }

  if (fallback) {
    return React__default.createElement(React.Suspense, {
      fallback: fallback
    }, children);
  }

  return React__default.createElement(React__default.Fragment, null, children);
};

exports.default = LazyMount;
//# sourceMappingURL=index.js.map
